import Vue from 'vue';
import Router from 'vue-router';
import Main from './modules/main/index.vue';
import ErrorPage from './modules/main/error-page/index.vue';
import homeRouter from './modules/home/router';
import studyRouter from './modules/study/router';

Vue.use(Router);

const routerConfig = {
    routes: [
        {
            path: '/',
            name: 'main',
            component: Main,
            children: [
                {
                    path: 'error-page-v/:code',
                    component: ErrorPage
                }
            ]
        },
    ]
};
const routes = routerConfig.routes[0];
routes.children = routes.children.concat(homeRouter(), studyRouter());
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
export default new Router(routerConfig);
